<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="نبذة-عن-الكاتب">
<h1><span dir="rtl">نبذةٌ عن الكاتب</span></h1>
<p><span dir="rtl">عصام بن راشد المغيزوي كاتبٌ ومبتكرٌ عماني الجنسيّة، وله العديد من المشاركاتِ المحليّة والعالميّة في مختلف المجالات، وقد حصدَ العديدَ من الجوائز على المستوى المحليّ في مجالَي، المقال الأدبي والبحث العلمي، كما تمّت دعوته لحضور مؤتمر الطّاقة النوويّة. ويميل في كتاباته الأدبيّة إلى مجالِ التنميةِ البشريّة؛ ليقينهِ التّام بأهمية هذا المجال في تحقيق الأهداف والأحلام</span>.</p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?bb88ee72